module.exports = __webpack_public_path__ + "static/media/3 Minutes Dairy Study.873ec232.doc";